import { Grid, TextField } from "@material-ui/core";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";
import { useGetDetailsBLExportQuery } from "../../../services/bl-export/BLExportService";
import NewBlFormRF from "./NewBlFormRF";
import {
  BLValues,
  CreateBLPayload,
} from "../../../interfaces/bl-export/request.bl.interface";
import { Skeleton } from "@material-ui/lab";

interface props {
  blToClone: Bl;
  submitAction: (values: CreateBLPayload) => void;
}

export const SkeletonBlForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField fullWidth variant="filled" disabled />
      </Grid>
      <Grid item xs={12} md={12}>
        <Skeleton width={"90px"} height={"16px"} />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField fullWidth variant="filled" multiline minRows={4} disabled />
      </Grid>
      <Grid item xs={12} md={12}>
        <Skeleton width={"90px"} height={"16px"} />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField fullWidth variant="filled" multiline minRows={4} disabled />
      </Grid>
      <Grid item xs={12} md={12}>
        <Skeleton width={"90px"} height={"16px"} />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField fullWidth variant="filled" multiline minRows={4} disabled />
      </Grid>
    </Grid>
  );
};

const CloneBLPreload = ({ blToClone, submitAction }: props) => {
  const { data, isLoading } = useGetDetailsBLExportQuery({
    id_bl: blToClone.id_bl,
    page: 0,
    pageSize: 100,
  });

  const blToCloneValues: BLValues = {
    cod_booking: "",
    dae: "",
    formaPago: blToClone.forma_pago || "",
    from: blToClone.from || "",
    hs_code: blToClone.hs_code || "",
    info_consignee: blToClone.info_consignee || "",
    info_notify: blToClone.info_notify || "",
    info_notifya: blToClone.info_notifya || "",
    info_shipper: blToClone.info_shipper || "",
    local_vessel: blToClone.local_vessel || "",
    num_bl: blToClone.num_bl || "",
    ocean_vessel: blToClone.ocean_vessel || "",
    place_delivery: blToClone.place_delivery || "",
    port_descharge: blToClone.port_descharge || "",
    port_loading: blToClone.port_loading || "",
    tipo_bl: blToClone.tipo_bl || "",
    id_cliente:
      blToClone.id_cliente !== undefined
        ? Number(blToClone.id_cliente)
        : undefined,
    shipper_reference: blToClone.shipper_reference,
    bl_details:
      data?.detBl?.map((detail) => ({
        tipo_empaque: detail.tipo_empaque,
        cod_contenedor: detail.cod_contenedor,
        commodities: "",
        desc_ad_cont: detail.desc_ad_cont,
        measurement: detail.measurement.toString(),
        num_bultos: detail.num_bultos,
        num_paquetes: detail.num_paquetes,
        peso_bruto: detail.peso_bruto.toString(),
        peso_neto: detail.peso_neto.toString(),
        ref_adicionales: detail.ref_adicionales,
        sellos: detail.sellos,
      })) || [],
  };

  if (isLoading) {
    return <SkeletonBlForm />;
  }

  return (
    <NewBlFormRF blToClone={blToCloneValues} submitAction={submitAction} />
  );
};

export default CloneBLPreload;
